import { inject, Inject, Injectable } from '@angular/core';

import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { PlatformService } from './platform.service';
import { TranslateService } from '../../shared/modules/translate/translate.service';

@Injectable({ providedIn: 'root' })
export class AlertService {
  private sound: HTMLAudioElement = undefined as any;
  constructor(
    private toastrService: ToastrService,
    private pt: PlatformService,
    @Inject(DOCUMENT) private document: Document,
    private translationService: TranslateService,
  ) {
    if (pt.isServer) return;
    this.toastrService = inject(ToastrService);
    this.initSound();
  }

  initSound() {
    if (this.sound) return;
    this.sound = this.document.createElement('audio');
    this.sound.src = 'assets/media/sound/notification-sound.mp3';
    this.sound.style.display = 'none';
    this.document.body.appendChild(this.sound);
  }

  private async playSound() {
    try {
      if (this.sound.pause) this.sound.pause();
      this.sound.currentTime = 0;
      this.sound.play();
    } catch (error) {}
  }

  async suucess(text: string, title: string | undefined = 'successfully') {
    if (this.pt.isServer) return;
    this.playSound();
    this.toastrService?.success(
      this.translationService.get(text),
      undefined,
      {},
    );
  }

  // warning(text: string = 'تحذير', title: string = 'تحذير') {
  //   if (this.pt.isServer) return;
  //   this.playSound();
  //   return Swal.fire({
  //     html: this.translationService.getValue(text),
  //     title: title,
  //     icon: 'warning',
  //     buttonsStyling: false,
  //     confirmButtonText: 'OK',
  //     customClass: {
  //       confirmButton: 'btn-primary',
  //       cancelButton: 'btn-outline-warning',
  //     },
  //   });
  // }

  async error_toastr(text: string, title: string = 'oops', translate = true) {
    if (this.pt.isServer) return;
    this.playSound();
    this.toastrService?.error(
      translate ? this.translationService.get(text) : text,
      undefined,
      // translate ? this.translationService.getValue(title) : title,
      {},
    );
  }

  error(text: string = 'Some Error Has Been', title: string = 'oops') {
    if (this.pt.isServer) return;
    this.playSound();
    this.error_toastr(text, title);

    // return Swal.fire({
    //   html: text as any,
    //   title: title as any,
    //   icon: 'error',
    //   buttonsStyling: false,
    //   confirmButtonText: 'OK' as any,
    //   customClass: {
    //     confirmButton: 'btn-primary ',
    //     cancelButton: 'btn-outline-warning',
    //   },
    // })
  }

  /** Confirmation Before Delete  
  confirmation(
    text: string,
    title: string = 'تحقق',
    options: SweetAlertOptions = {},
  ) {
    if (this.pt.isServer) return;
    this.playSound();
    return Swal.fire({
      text: this.translationService.getValue(text) as any,
      title: this.translationService.getValue(title) as any,
      icon: options.icon || 'warning',
      buttonsStyling: false,
      confirmButtonText: options.confirmButtonText || ('نعم احذف' as any),
      cancelButtonText: options.cancelButtonText || ('الغاء' as any),

      showCancelButton: true,
      customClass: {
        confirmButton: 'btn-primary ',
        cancelButton: 'btn-outline-warning',
      },
      ...options,
    });
  }
*/
  catchError(error: Error | any) {
    if (this.pt.isServer) return;
    const title = 'Opps';
    this.error_toastr(error?.error.message, title, false);
  }
}
